// Client for the live-preview debug log (/api/livepreview/preview-log/*).
//
// One per-object log tree serves every preview surface (transaction, visual,
// dashboard), so this single client backs the "Preview log" 3-dot menu item in
// all of them.

import api from './client'

export interface PreviewLogEntry {
  ts: string
  run_id: string
  kind: string
  action: string
  status: 'OK' | 'WARN' | 'ERROR' | string
  user_id: string
  outcome: string
}

/** Compact step-by-step run summary for an object (newest first). */
export async function fetchPreviewLogSummary(
  project: string,
  objName?: string,
  limit = 100,
): Promise<{ ok: boolean; entries: PreviewLogEntry[] }> {
  const res = await api.get('/livepreview/preview-log/summary', {
    params: { project, obj_name: objName, limit },
  })
  return res.data
}

/** Full verbose detail text for one run (or 404 when there's no detail). */
export async function fetchPreviewLogDetail(
  project: string,
  runId: string,
  objName?: string,
): Promise<{ ok: boolean; run_id: string; detail: string }> {
  const res = await api.get('/livepreview/preview-log/detail', {
    params: { project, run_id: runId, obj_name: objName },
  })
  return res.data
}
